"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readbackType = void 0;
const closure_1 = require("../closure");
const Cores = __importStar(require("../core"));
const ctx_1 = require("../ctx");
const Errors = __importStar(require("../errors"));
const Neutrals = __importStar(require("../neutral"));
const readback_1 = require("../readback");
const solution_1 = require("../solution");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
function readbackType(mod, ctx, type) {
    type = (0, solution_1.solutionAdvanceValue)(mod, type);
    switch (type["@kind"]) {
        case "TypedNeutral": {
            /**
               The `type` in `TypedNeutral` are not used.
            **/
            return (0, readback_1.readbackNeutral)(mod, ctx, type.neutral);
        }
        case "Type": {
            return Cores.Var("Type");
        }
        case "String": {
            return Cores.Var("String");
        }
        case "Trivial": {
            return Cores.Var("Trivial");
        }
        case "Pi": {
            const name = type.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const argTypeCore = readbackType(mod, ctx, type.argType);
            const retTypeValue = (0, closure_1.closureApply)(type.retTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
            const retTypeCore = readbackType(mod, ctx, retTypeValue);
            return Cores.Pi(freshName, argTypeCore, retTypeCore);
        }
        case "PiImplicit": {
            const name = type.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const argTypeCore = readbackType(mod, ctx, type.argType);
            const retTypeValue = (0, closure_1.closureApply)(type.retTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
            const retTypeCore = readbackType(mod, ctx, retTypeValue);
            return Cores.PiImplicit(freshName, argTypeCore, retTypeCore);
        }
        case "Sigma": {
            const name = type.cdrTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.carType, Neutrals.Var(freshName));
            const carTypeCore = readbackType(mod, ctx, type.carType);
            const cdrTypeValue = (0, closure_1.closureApply)(type.cdrTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.carType, ctx);
            const cdrTypeCore = readbackType(mod, ctx, cdrTypeValue);
            return Cores.Sigma(freshName, carTypeCore, cdrTypeCore);
        }
        case "ClazzNull":
        case "ClazzCons":
        case "ClazzFulfilled": {
            return (0, readback_1.readbackClazz)(mod, ctx, type);
        }
        case "Equal": {
            return Cores.Ap(Cores.Ap(Cores.Ap(Cores.Var("Equal"), readbackType(mod, ctx, type.type)), (0, readback_1.readback)(mod, ctx, type.type, type.from)), (0, readback_1.readback)(mod, ctx, type.type, type.to));
        }
        default: {
            throw new Errors.ReadbackError(`readbackType is not implemented for type: ${type["@kind"]}`);
        }
    }
}
exports.readbackType = readbackType;
//# sourceMappingURL=readbackType.js.map